class TerminalDirective
  @$inject: ["socket"]
  constructor: (socket)->
    class Terminal
      restrict: "C"
      scope:
        device: "="
      link: (scope, element, attrs)->
        scope.$watch "device", (val)=>
          if val
            opts =
              rows: 20
              useStyle: true
              screenKeys: true
              cursorBlink: false
            term = require('term.js/src/term.js')(opts)
            term.open element[0]
            term.on 'data', (data) ->
              socket.emit 'web command',
                command: data
            socket.emit 'init ssh', val._id, (err, key) =>
              if err
                scope.rejected = "Error connected to the device."
              socket.on 'web command', (command) ->
                term.write command

              socket.emit "web command",
                command: '\r'

              socket.on "connection renew", (data) ->
                term.write '\r\x1b[31mConnection Refused.\x1b[m\r\n'
                term.destroy()



    return new Terminal();


module.exports = TerminalDirective



// WEBPACK FOOTER //
// ./src/component/device/terminal/terminal.coffee